import { Navigate, useLocation } from "react-router-dom";
import { findPage } from "../shell/nav";
import { fromUrl, toUrl } from "../shell/routes";

const WHEN: Record<string, string> = {
  A3: "masters (step A3)", A4: "entry (step A4)", A5: "reports (step A5)", later: "the module screens, after the core app",
};

export function Placeholder() {
  const here = useLocation().pathname;
  const path = fromUrl(here);
  const page = findPage(path);
  if (!page) return <section className="page"><h1>Not found</h1><p className="muted">There's no page at this address.</p></section>;
  // an older address of a page that has a screen: go there
  const url = toUrl(page.path);
  if (url.split("?")[0] !== here) return <Navigate to={url} replace />;
  return (
    <section className="page">
      <p className="crumb muted">{page.section.title}</p>
      <h1>{page.title}</h1>
      <p className="muted">This screen comes with {WHEN[page.step] ?? page.step}. The engine behind it is already built and tested.</p>
    </section>
  );
}
